<template>
  <v-menu bottom offset-y left>
    <v-btn slot="activator" flat small icon>
      <!--
        CORREÇÃO: mdi-settings não existe na versão 7.4.47 do @mdi/font
        Usando mdi-cog que é o ícone padrão para configurações no MDI
      -->
      <v-icon class="grey--text text--darken-2">mdi-cog</v-icon>
    </v-btn>
    <v-card class="settings-card">
      <div class="settings-options pt-2 pb-2">
        <!--        <v-flex xs4 class="settings-option">-->
        <!--          <img src="/static/images/settings/new-icons/icon-type-folder.svg" width="56">-->
        <!--          <span class="mt-1 setting-title">Tipos de Processo</span>-->
        <!--        </v-flex>-->

        <!--        <v-flex xs4 class="settings-option">-->
        <!--          <img src="/static/images/settings/new-icons/icon-type-document.svg" width="56">-->
        <!--          <span class="mt-1 setting-title">Tipos de Documento</span>-->
        <!--        </v-flex>-->

        <v-flex xs4 class="settings-option" @click="gotoRouterName('DispatchesList')">
          <img src="/static/images/settings/new-icons/icon-folder-dispatches.svg" width="56">
          <span class="mt-1 setting-title">Despachos Padrão</span>
        </v-flex>

        <!--        <v-flex xs4 class="settings-option">-->
        <!--          <img src="/static/images/settings/new-icons/icon-header-footer.svg" width="56">-->
        <!--          <span class="mt-1 setting-title">Cabeçalho e Rodapé</span>-->
        <!--        </v-flex>-->

        <!--        <v-flex xs4 class="settings-option">-->
        <!--          <img src="/static/images/settings/new-icons/icon-access-clients.svg" width="56">-->
        <!--          <span class="mt-1 setting-title">Clientes</span>-->
        <!--        </v-flex>-->

        <v-flex xs4 class="settings-option"  @click="gotoRouterName('Roles')">
          <img src="/static/images/settings/icon-access-permissions.svg" width="56">
          <span class="mt-1 setting-title">Cargos</span>
        </v-flex>

        <v-flex xs4 class="settings-option" @click="gotoRouterName('AdministrativeUnits')">
          <img src="/static/images/settings/new-icons/icon-sectors.svg" width="56">
          <span class="mt-1 setting-title">Setores</span>
        </v-flex>

        <v-flex xs4 class="settings-option " @click="gotoRouterName('Employees')">
          <img src="/static/images/settings/new-icons/icon-administrative-units.svg" width="56">
          <span class="mt-1 setting-title">Funcionários</span>
        </v-flex>

        <v-flex xs4 class="settings-option " @click="gotoRouterName('DocumentTypesList')">
          <img src="/static/images/settings/file-save-update.png" width="56">
          <span class="mt-1 setting-title">Documentos<br/> Pré-definidos</span>
        </v-flex>

        <v-flex xs4 class="settings-option" @click="gotoRouterName('Notices')">
          <img src="/static/images/settings/icon-system-notifications.svg" width="56">
          <span class="mt-1 setting-title">Avisos</span>
        </v-flex>

        <v-flex xs4 class="settings-option" @click="gotoRouterName('GeneralSettings')">
          <img src="/static/images/settings/new-icons/icon-general-settings.svg" width="56">
          <span class="mt-1 setting-title">Configurações Geral</span>
        </v-flex>

        <v-flex xs4 class="settings-option" @click="gotoRouterName('Entities')">
          <img src="/static/images/settings/new-icons/icon-access-clients.svg" width="56">
          <span class="mt-1 setting-title">Entidades</span>
        </v-flex>

        <v-flex xs4></v-flex> <!-- empty flex to fill the space -->
      </div>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    name: 'settings',
    methods: {
      gotoRouterName(name) {
        this.$router.push({name});
      },
    },
  };
</script>

<style lang="scss">
  h3 {
    margin-bottom: 15px;
  }

  .settings-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 310px;
  }

  .settings-options {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .settings-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 8px !important;
  }

  .setting-title {
    font-size: 9px;
  }

  .settings-icon-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
  }

  .settings-icon-btn .v-icon {
    color: rgba(255,255,255,0.7) !important;
    font-size: 20px !important;
  }

  .settings-icon-btn:hover .v-icon {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/Settings.vue